
import { Header } from "../Figma/Header";
import { Hero } from "../Figma/Hero";
import { HowItWorks } from "../Figma/HowItWorks";
import { WhoItsFor } from "../Figma/WhoItsFor";
import { Articles } from "../Figma/Articles";
import { RealStories } from "../Figma/RealStories";
import { Footer } from "../Figma/Footer";
import "./index.css";

// Dividers
import DividerHero from "@/assets/divider-hero.svg";
import DividerWhoTop from "@/assets/divider-who-top.svg";
import DividerWhoBottom from "@/assets/divider-who-bottom.svg";
import DividerRealTop from "@/assets/divider-real-top.svg";
import DividerRealBottom from "@/assets/divider-real-bottom.svg";

function HomeComponent() {
  return (
    <div className="min-h-screen w-full flex flex-col">
      <Header />
      <main className="flex-1 w-full mx-auto">
        {/* Hero */}
        <Hero />
        <img src={DividerHero} className="w-full mx-auto" alt="" />
        {/* How It Works */}
        <HowItWorks />
        {/* Who It's For */}
        <img src={DividerWhoTop} className="w-full mx-auto" alt="" />
        <WhoItsFor />
        <img src={DividerWhoBottom} className="w-full mx-auto" alt="" />
        {/* Articles */}
        <Articles />
        {/* Real Stories */}
        <img src={DividerRealTop} className="w-full mx-auto -mb-[3px]" alt="" />
        <RealStories />
        <img src={DividerRealBottom} className="w-full mx-auto" alt="" />
      </main>
      <Footer />
    </div>
  );
}

export default HomeComponent;
export { HomeComponent };  